import * as styles from './components/styles.scss';
import TaskView from './components/TaskView';
import { TASK_TYPE } from './constants';
import type { TaskViewPayload } from './schema';
import createNewTaskAsset from './factory/createNewTaskAsset';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { AssetAriaLabel, registerAsset, DEFAULT_MIN_ASSET_WIDTH } from 'owa-timestream-asset-sdk';
import { canUseToDoFeatures } from 'owa-todo-utils/lib/utils/moduleAccessUtils';
import {
    taskName,
    assetErrorTask,
    taskTooltip,
    ariaLabelTaskComplete,
    ariaLabelTaskIncomplete,
} from './taskStrings.locstring.json';

export const taskItem = registerAsset<TaskViewPayload>({
    type: TASK_TYPE,
    iconName: ControlIcons.ToDoLogoOutline,
    customRenderDueDate: true,
    preventFullControlOverTask: true,
    viewStyle: styles.taskAssetBase,
    isAssetEnabled: canUseToDoFeatures,
    getToolName: () => loc(taskName),
    getTooltip: () => loc(taskTooltip),
    getErrorMessage: () => loc(assetErrorTask),
    unsupportedDefaultCommands: [],
    CanvasView: TaskView,
    createAssets: createNewTaskAsset,
    createEmptyAsset: () => ({
        type: TASK_TYPE,
        width: DEFAULT_MIN_ASSET_WIDTH,
        payload: {
            taskId: '',
        },
    }),
    getAriaLabel: (payload: TaskViewPayload) => {
        const assetDescription =
            (payload.taskSubject ? payload.taskSubject : '') +
            ', ' +
            (payload.isComplete ? loc(ariaLabelTaskComplete) : loc(ariaLabelTaskIncomplete));
        return loc(AssetAriaLabel.assetAriaLabel, loc(taskName), assetDescription);
    },
    getTitleString: getTaskTitle,
    getSearchString: getTaskTitle,
    assetResizeConfiguration: () => ({
        minHeight: 85,
        minWidth: DEFAULT_MIN_ASSET_WIDTH,
    }),
});

function getTaskTitle(payload: TaskViewPayload) {
    return payload.taskSubject;
}
